export default "<tc-list #tcList></tc-list>\r\n";